import { render, staticRenderFns } from "./BaseSearchInput.vue?vue&type=template&id=63e830d3"
import script from "./BaseSearchInput.vue?vue&type=script&lang=js"
export * from "./BaseSearchInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports